function setDateToMinuteWith0SecondsAnd0Millis(date: Date, minutes: number) {
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
}

function getDateHoursFromDateOnTheExactMinute(fromDate: Date, hourAdjustment: number, minute: number) {
  const MILLIS_PER_HOUR = 60 * 60 * 1000;
  const nextDate = new Date(fromDate.getTime() + (hourAdjustment * MILLIS_PER_HOUR));
  setDateToMinuteWith0SecondsAnd0Millis(nextDate, minute);
  return nextDate;
}

export class TimeSlices {
  public readonly sliceLengthInSeconds: number;
  public readonly sliceUntil: number;

  constructor(dateToSlice: Date, sliceLengthInSeconds: number = 120, sliceUntil: number = 24) {
    this.sliceLengthInSeconds = sliceLengthInSeconds;
    this.sliceUntil = sliceUntil;

  }

  public nextSliceClosestToTime(dateTime: Date): Date {
    const milliSecondsMoreThanCycleMultiple = dateTime.getTime() % this.sliceLengthInMilliSeconds();
    const roundedDownToCycle = dateTime.getTime() - milliSecondsMoreThanCycleMultiple;
    return this.getFollowingCycle(new Date(roundedDownToCycle));
  }

  public getSecondsRemainingInCurrentCycle = (now: Date): number => {
    const nowWithoutMilliSeconds = this.timeWithoutMilliSeconds(now);
    const nextSliceMillis = this.nextSliceClosestToTime(nowWithoutMilliSeconds).getTime();
    return Math.floor((nextSliceMillis - nowWithoutMilliSeconds.getTime()) / 1000);
  }

  public previousSliceClosestToTime(dateTime: Date): Date {
    const milliSecondsMoreThanCycleMultiple = dateTime.getTime() % this.sliceLengthInMilliSeconds();
    const roundedDownToCycle = dateTime.getTime() - milliSecondsMoreThanCycleMultiple;
    return new Date(roundedDownToCycle);
  }

  public getFollowingCycle(cycle: Date): Date {
    return new Date(cycle.getTime() + this.sliceLengthInMilliSeconds());
  }

  public getPreviousCycle(cycle: Date): Date {
    return new Date(cycle.getTime() - this.sliceLengthInMilliSeconds());
  }

  public getFutureCycleFrom(startCycle: Date, numberOfCyclesToMoveForward: number): Date {
    let iterator = this.nextSliceClosestToTime(startCycle);
    for (let i = 1; i < numberOfCyclesToMoveForward; i++) {
      iterator = this.getFollowingCycle(iterator);
    }
    return iterator;
  }

  public getFutureHourCycleFrom(startCycle: Date, numberOfHoursToMoveForward: number): Date {
    const slicesInHour = 60 * 60 / this.sliceLengthInSeconds;
    return this.getFutureCycleFrom(startCycle, slicesInHour * numberOfHoursToMoveForward);
  }

  public getNextClassSlice(cycle: Date): Date {
    const minutes = cycle.getMinutes();
    let hourAdjustment = 0;
    let nextClassMinute = 0;

    if (minutes >= 30) {
      hourAdjustment = 1;
      nextClassMinute = 0;
    } else {
      nextClassMinute = 30;
    }

    const newCycle = getDateHoursFromDateOnTheExactMinute(cycle, hourAdjustment, nextClassMinute);
    return this.previousSliceClosestToTime(newCycle);
  }

  public getCorrectSliceForQueue(cycle: Date): Date | undefined {
    const minutes = cycle.getMinutes();
    let hourAdjustment = 0;
    let nextClassMinute = 0;

    if (minutes >= 40) {
      hourAdjustment = 1;
      nextClassMinute = 0;
    } else if (minutes >= 10 && minutes < 30) {
      nextClassMinute = 30;
    } else {
      return this.previousSliceClosestToTime(cycle);
    }

    const newCycle = getDateHoursFromDateOnTheExactMinute(cycle, hourAdjustment, nextClassMinute);
    return this.previousSliceClosestToTime(newCycle);
  }

  public sliceLengthInMilliSeconds() {
    return this.sliceLengthInSeconds * 1000;
  }

  public isHalfWorkoutBeforeLastStage(date: Date): boolean {
    const minute = date.getMinutes();
    const seconds = date.getSeconds();
    return (minute === 26 || minute === 56) && seconds === 0;
  }

  public isFullWorkoutBeforeLastStage(date: Date): boolean {
    const minute = date.getMinutes();
    const seconds = date.getSeconds();
    return minute === 46 && seconds === 0;
  }

  public numberOfCyclesSinceStart(startTime: Date, now: Date): number {
    const difference = now.getTime() - startTime.getTime();
    if (difference < 0) {
      return 0;
    }
    const cycles = Math.trunc(difference / this.sliceLengthInMilliSeconds());
    return cycles;
  }

  private timeWithoutMilliSeconds = (date: Date) => {
    return new Date(date.setMilliseconds(0));
  }
}
